var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24"
    }
  }, _vm.$listeners), [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#000",
      "d": "M11.519.037C5.167.037 0 5.204 0 11.555s5.167 11.519 11.519 11.519c6.35 0 11.518-5.167 11.518-11.519C23.037 5.204 17.87.037 11.52.037"
    }
  }), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "m11.182 6.34.06.002c.782 0 1.42-.613 1.453-1.397.032-.816-.601-1.48-1.442-1.514h-.011c-.783 0-1.422.613-1.454 1.396-.033.8.592 1.48 1.394 1.514m1.434 11.891V7.959H9.122v1.448h1.43v8.825h-1.3v1.448h4.665v-1.448z"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }